import React, { SVGProps } from "react";

export const AdinFour = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={172}
      height={172}
      viewBox="0 0 172 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={85.6924}
        cy={86.1684}
        r={85.352}
        fill="white"
        fillOpacity={0.59}
      />
      <path
        d="M129.76 46.4828C118.557 34.033 102.494 26.8955 85.6957 26.8955C68.8972 26.8955 52.8285 34.033 41.6254 46.4828C31.8212 57.3699 26.4204 71.4641 26.4204 86.1707C26.4204 100.877 31.8212 114.966 41.6254 125.858C52.8285 138.302 68.8911 145.446 85.6957 145.446C102.5 145.446 118.557 138.308 129.766 125.858C139.57 114.966 144.971 100.871 144.971 86.1707C144.971 71.47 139.57 57.3757 129.766 46.4828H129.76ZM121.64 119.141C112.475 129.322 99.3741 135.159 85.6896 135.159C72.0051 135.159 58.9044 129.322 49.7388 119.141C41.6133 110.114 37.143 98.4106 37.143 86.1707C37.143 73.9308 41.6194 62.2274 49.7388 53.2005C58.9044 43.0191 72.0051 37.1819 85.6896 37.1819C99.3741 37.1819 112.475 43.0191 121.64 53.2005C129.766 62.2274 134.236 73.9308 134.236 86.1707C134.236 98.4106 129.76 110.114 121.634 119.141H121.64Z"
        fill="#169FED"
      />
      <path
        d="M115.437 58.3325C107.828 49.8829 96.99 45.0371 85.6896 45.0371C74.3892 45.0371 63.5511 49.8829 55.9425 58.3325C49.1002 65.9307 45.3354 75.8147 45.3354 86.1653C45.3354 96.5158 49.1002 106.4 55.9425 113.998C63.5511 122.448 74.3892 127.293 85.6896 127.293C96.99 127.293 107.828 122.448 115.437 113.998C122.279 106.4 126.044 96.5158 126.044 86.1653C126.044 75.8147 122.279 65.9307 115.437 58.3325ZM107.317 107.28C101.746 113.467 93.8638 117.013 85.6896 117.013C77.5154 117.013 69.6331 113.467 64.062 107.28C58.9044 101.548 56.058 94.0492 56.058 86.1653C56.058 78.2813 58.8983 70.7823 64.062 65.0501C69.6331 58.8631 77.5154 55.3177 85.6896 55.3177C93.8638 55.3177 101.746 58.8631 107.317 65.0501C112.475 70.7823 115.321 78.2813 115.321 86.1653C115.321 94.0492 112.481 101.548 107.317 107.28Z"
        fill="#169FED"
      />
      <path
        d="M85.6962 63.1787C73.8788 63.1787 64.2632 73.4943 64.2632 86.1715C64.2632 98.8488 73.8788 109.164 85.6962 109.164C97.5135 109.164 107.129 98.8488 107.129 86.1715C107.129 73.4943 97.5135 63.1787 85.6962 63.1787ZM85.6962 98.8779C79.7906 98.8779 74.9858 93.1749 74.9858 86.1657C74.9858 79.1565 79.7906 73.4535 85.6962 73.4535C91.6018 73.4535 96.4066 79.1565 96.4066 86.1657C96.4066 93.1749 91.6018 98.8779 85.6962 98.8779Z"
        fill="#169FED"
      />
    </svg>
  );
};
